module.exports = __webpack_public_path__ + "static/media/CodingEthereumSmartContracts.8b2023a1.png";